import { render, staticRenderFns } from "./web-editor.vue?vue&type=template&id=4b1369e8"
import script from "./web-editor.vue?vue&type=script&lang=js"
export * from "./web-editor.vue?vue&type=script&lang=js"
import style0 from "./web-editor.vue?vue&type=style&index=0&id=4b1369e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports